<script>
import Multiselect from 'vue-multiselect'
import { authComputed } from '@state/helpers'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'EuroCouponsThirdpartySelector',
  components: {
    Multiselect,
  },
  props: {
    value: {
      required: false,
      default: null,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    description: {
      type: String,
      required: false,
      default: '',
    },

    label: {
      type: String,
      required: true,
    },

    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },

  mounted: function() {},

  methods: {
    labelOfOption(opt) {
      let context = this
      let optionFound = context.options.find((x) => x.value === opt)
      return optionFound.label
    },
  },
}
</script>

<template>
  <b-container class="p-0">
    <b-form-group :label="$t(label)" :description="description">
      <b-row>
        <b-col :md="12">
          <Multiselect
            class="border-primary"
            v-model="inputVal"
            :multiple="multiple"
            :options="options.map((x) => x.value)"
            :custom-label="(opt) => labelOfOption(opt)"
            :selected-label="$t('selected')"
            :select-label="$t('press_enter_to_select')"
            :deselect-label="$t('press_enter_to_remove')"
            :placeholder="$t('select_option')"
          >
          </Multiselect>
        </b-col>
      </b-row>
    </b-form-group>
  </b-container>
</template>
<style lang="scss">
.multiselect__tags {
  min-height: 38px;
  display: block;
  max-height: 30px;
  padding: 6px 40px 0 8px;
  border-radius: 5px;
  background: #fff;
  border-color:#121a79;
  font-size: 14px;
}
</style>
